require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reducing-homeless-related-crime.json") })
        }
      }, "path---reducing-homeless-related-crime");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reducing-homeless-related-crime!./.cache/json/reducing-homeless-related-crime.json
// module id = 971
// module chunks = 231608221292675